import React, { memo } from "react";
import { Icon } from "@abb/abb-common-ux-react";
import styled from "styled-components";
import { ICellRendererParams } from "ag-grid-community";
import { commonUXTheme } from "../../../styles/commonUXVariables";

export interface GridIconRendererProps extends ICellRendererParams {
  showIcon: boolean;
  icon: string;
  text?: string;
  color?: string;
  onClick?: () => void;
  isInactive?: boolean;
  isClickable?: boolean;
}

export const IconWithCursorPointer = styled(Icon)<{ hasText?: boolean }>`
  margin: ${(props) => (props.hasText ? "auto 0 auto 0" : "auto")};
`;

const IconContainerDiv = styled.div<{ isClickable?: boolean; hasText?: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.hasText ? "space-between" : "center")};
  cursor: ${(props) => (props.isClickable ? "pointer !important" : "default")};
`;

const getColor = (isInactive: boolean | undefined): string | undefined => {
  if (isInactive === true) {
    return commonUXTheme.colors.grey30;
  }
};

export const GridIconRenderer = memo((props: GridIconRendererProps) => {
  if (!props.showIcon && !props.text) {
    return null;
  }

  return (
    <IconContainerDiv
      isClickable={!!props.onClick || !!props.isClickable}
      style={{
        height: props.node.rowHeight + "px"
      }}
      onClick={props.onClick}
      hasText={props.text !== undefined}
    >
      {props.text ? <div>{props.text}</div> : null}
      {props.showIcon ? (
        <IconWithCursorPointer
          name={props.icon}
          color={props.color ? props.color : getColor(props.isInactive)}
          hasText={props.text !== undefined}
        />
      ) : null}
    </IconContainerDiv>
  );
});
